import React, { useImperativeHandle, useEffect, useState, useMemo } from 'react';
import { message, Transfer } from 'antd';
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import useSyncObjectRelationships from '../../gql/hooks/useSyncObjectRelationships';
import useGroups from '../../gql/hooks/useGroups';
import useLocales from '../../gql/hooks/useLocales'; 
import './styles.less';

const FormCustomerLocales = ( { form, modifiedCallback, ref } ) => {
    const [ localeIds, setLocaleIds ] = useState( [] );
    const [ sync ] = useSyncObjectRelationships();
    const { groups, groupsLoading, groupsError } = useGroups();
    const { locales, getLocaleLabel } = useLocales();

    useImperativeHandle( ref, () => ( {
        reset() {
            reset();
        },
        isModified() {
            return form.getFieldValue( 'localeIdsAreModified' );
        },
        async syncData() {
            const syncData = courseFormUtils.getLocalesSyncValues( form );
            
            if ( syncData ) {
                try {
                    await sync( { variables: { input: syncData } } );
                    courseFormUtils.updateLocaleValues( form, syncData.relatedResourceIds );
                    reset();
                    return true;
                } catch ( error ) { 
                    console.error( 'Error saving!', error );  
                    message.error( 'Error saving!' );  
                    return false;
                } 
            }
        }
    } ) );
     
    const reset = () => {
        form.setFieldsValue( { localeIdsAreModified: false } ); 
        form.setFieldsValue( { localeIdsModified: [] } ); 
        setLocaleIds( form.getFieldValue( 'localeIds' ) );
        modifiedCallback( false ); 
    };

    const listData = useMemo( () => { 
        if ( groups && locales ) {
            return groups.filter( i => {
                return i.attributes.find( a => a.name === 'locale' );
            } ).map( a => {
                return { ...a, name: getLocaleLabel( a.name ) };
            } );
        } else {
            return [];
        }
    }, [ groups, locales ] );

    useEffect( () => listData && setLocaleIds( form.getFieldValue( 'localeIds' ) ), 
        [ listData, setLocaleIds ] );

    const handleChangeIds = ( values ) => { 
        setLocaleIds( values ); 

        if ( JSON.stringify( values ) !== JSON.stringify( form.getFieldValue( 'localeIds' ) ) ) {
            form.setFieldsValue( { localeIdsAreModified: true } ); 
            form.setFieldsValue( { localeIdsModified: values } ); 
            modifiedCallback( true );
        } else {
            form.setFieldsValue( { localeIdsAreModified: false } ); 
            form.setFieldsValue( { localeIdsModified: [] } ); 
            modifiedCallback( false );
        }
    };

    return (
        <div className="form-item-customer-locales">
            { !groupsLoading && !groupsError &&
                <>
                    <h4 style={ { marginBottom: '8px' } }>Customer Locales</h4>

                    <Transfer
                        dataSource={ listData }
                        showSearch
                        titles={ [ 'Available', 'Selected' ] }
                        targetKeys={ localeIds }
                        onChange={ handleChangeIds }
                        render={ i => i.name || <span className='italic'>No Name</span> }
                        filterOption={ ( input, option ) => 
                            option.name.toLowerCase().includes( input.toLowerCase() )
                        }
                    />
                </>
            }
        </div>
    );
};

export default FormCustomerLocales;
